import { useState } from 'react';

/** @deprecated Use `useToggle` from `react-use` instead. */
export const useModalToggle = (defaultValue = false): [boolean, () => void] => {
  const [modalToggle, setModalToggle] = useState(defaultValue);
  const modalToggleHandler = () => setModalToggle((value) => !value);

  return [modalToggle, modalToggleHandler];
};
